<template>
	<div ref="scrollContainer" id="page-po" v-loading.fullscreen.lock="fullScreenLoading" class="scrollable only-y">
    <el-row>
      <el-col   style="padding-left:10px;">
        <PurchaseOrder :po="selectedPurchaseOrder" @close="closePO" @editPurchaseOrder="editPo" @deleted="close()" @duplicate="handleDuplication"></PurchaseOrder>
      </el-col>
    </el-row>
    <PurchaseOrderDialog :dialogVisible.sync="poDialogVisible"  :inventoryId="inventoryId"  :editSelectedPurchaseOrder="editSelectedPurchaseOrder"  @close="closePODialog"></PurchaseOrderDialog>
	</div>
</template>

<script>
import axios from "axios"
import PurchaseOrderAPI from '@/services/API/purchase-order'
import PurchaseOrderDialog from './components/purchase-order-dialog.vue'
import PurchaseOrder from './components/purchase-order.vue'
import PurchaseOrderProcessAPI from '@/services/API/purchase-order-process'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Purchase-Order',
  data() {
    return {
      fullScreenLoading : true,
      po : null,
			poDialogVisible : false,
			editSelectedPurchaseOrder : false,
    };
  },components: {
    PurchaseOrderDialog,
    PurchaseOrder
  },
	methods: {
    close(){
			this.$router.go(-1);
		},
		openPODialog(){
			this.poDialogVisible=true;
		},
		handleDuplication(po){
			this.duplicate(po);
			this.openPODialog();
		},
		editPo(po){
      _.forEach(po.lines, line => {
				if (line.fk_product_item_id != null) {
					line.productItem = { id: line.fk_product_item_id }
				}
			})
			this.setPurchaseOrder({ purchaseOrder: _.cloneDeep(this.selectedPurchaseOrder), products: this.selectedPurchaseOrderProducts, productItems: this.selectedPurchaseOrderProductItems })
        .then(() => {
          this.editSelectedPurchaseOrder = true;
          this.openPODialog();
        })

		},
    closePO(){
      this.$router.go(-1);
    },
    closePODialog(){
      this.poDialogVisible=false;
      this.editSelectedPurchaseOrder = false;
    },
    getPurchaseOrder(){
      return PurchaseOrderProcessAPI.getPurchaseOrder(this.purchaseOrderId)
        .then(result=>{
            this.po = result.purchaseOrder;
            return result;
        })
    },
		...mapActions('purchaseOrders', ['setSelectedPurchaseOrder','initPurchaseOrders']),
		...mapActions('purchaseOrderEditor', ['setPurchaseOrder','duplicate'])
	},
	computed: {
		purchaseOrderId(){
			return this.$route.params.purchaseOrderId;
		},
    inventoryId(){
			return this.$route.params.id;
		},
		...mapState('purchaseOrders',['selectedPurchaseOrder','selectedPurchaseOrderProducts', 'selectedPurchaseOrderProductItems'])
	},
  mounted(){
  },
	created(){
      this.fullScreenLoading=true;
			this.initPurchaseOrders({inventoryId : this.inventoryId});
      this.getPurchaseOrder()
        .then((result)=>{
					this.setSelectedPurchaseOrder({index:null, selectedPurchaseOrder:result.purchaseOrder, products: result.products, productItems: result.productItems });
          this.fullScreenLoading=false;
        })
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

</style>
